import { all, call } from "redux-saga/effects";
import onCreateDepartment from "./createDepartment";
import onEditDepartment from "./editDepartment";
import onDeleteDepartment from "./deleteDepartment";
import onGetAllDepartments from "./getAllDepartments";
export default function* departmentsSaga() {
  yield all([
    call(onGetAllDepartments),
    call(onCreateDepartment),
    call(onEditDepartment),
    call(onDeleteDepartment),
  ]);
}
